import { ConfigService } from './../../share/services/config.service';
import { Component } from '@angular/core';
import { Router } from '@angular/router'; 
import { AppService } from '../../app.service';
import FetrapiEnums from '../../share/enum/enums';
import { ApiService } from '../../share/services/api.service';
import { SessionService } from '../../share/services/session.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent {

  constructor(
    private appService: AppService,
    private api: ApiService,
    private router: Router,
    private configService: ConfigService,
    private sessionService: SessionService
  ) {
    this.appService.pageTitle = 'Home';
  }

  ngOnInit() {
    console.log('HOME ONINIT');

    var redicrectTo = '/login';

    if (!this.sessionService.hasFetrapiSession()) {
      console.log('NO SESSION');
      this.router.navigate([redicrectTo]);
      return;
    } 

    //If site is deactivate we redirect to the maintenance page
    if(!this.configService.isActiveEnvironment()) {
      this.router.navigate(['/maintenance']);
      return;
    }

    const maingroupName = this.sessionService.getMaingroupName();
    if (maingroupName == FetrapiEnums.MainGroups.ChIIIMember || maingroupName == FetrapiEnums.MainGroups.ADCRMember) {
      redicrectTo = '/zoi';
    }

    if (maingroupName == FetrapiEnums.MainGroups.FetrapiMember) {
      redicrectTo = '/grid';
    }
    if (maingroupName == FetrapiEnums.MainGroups.FetrapiAdmin || maingroupName == FetrapiEnums.MainGroups.SuperUser) {
      redicrectTo = '/grid';
    }

    console.log('REDIRECTTO', redicrectTo);

    this.router.navigate([redicrectTo]);
  }
}

